import type { ChapterConfig } from './types'
import { commonTexts } from './common'

/**
 * Rocnovel 品牌 - Chapter 页面配置
 */
export const chapterConfig: ChapterConfig = {
  texts: commonTexts,
  colors: {
    coinsGradient: 'linear-gradient(180deg, #A778FE, #ffffff)',
    coinsPopupText1: '#FFFFFF',
    coinsPopupText2: '#FF873F',
    coinsPopupText3: '#65686F',
    coinsPopupText4: '#FFFFFF',
    // 充值弹窗颜色配置
    vipBg: '#F3EFFF',
    subscribeActiveBg: '#F3F5FA',
    purpleTextGradient: 'linear-gradient(180deg, #BEA9FF 0%, #D3C5FB 70%, #F3EFFF 100%)',
    pinkGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
    // 会员订阅背景图
    memberSubscribeBg: '/images/rocnovel/chapter/member_subscribe_bg.webp',
  },
}
